import { setAccessToken } from "@/services/storage.service";

const TOKEN_PARAM = "token";

export function bootstrapPrintToken(): void {
  const url = new URL(window.location.href);
  const fragmentParams = new URLSearchParams(url.hash.replace(/^#/, ""));
  const token = fragmentParams.get(TOKEN_PARAM);
  if (!token) {
    return;
  }

  try {
    setAccessToken(token);
  } finally {
    fragmentParams.delete(TOKEN_PARAM);
    const remainingFragment = fragmentParams.toString();
    url.hash = remainingFragment ? `#${remainingFragment}` : "";
    window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`);
  }
}
